import { Button, Card, CardBody, Heading, Link } from '@apollo/orbit';
import { Moon } from '@apollo/space-kit/illustrations/Moon';
import React from 'react';

import { PageTitle } from 'src/components/common/pageTitle/PageTitle';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { useLDFlag } from 'src/lib/launchDarkly';
import { DocsRouter } from 'src/lib/routers';

export const PersistedQueryListPageEmpty = ({
  persistedQueryList,
  onPublishClick,
}: {
  persistedQueryList: NonNullable<
    NonNullable<
      GraphQLTypes.PersistedQueryListQuery['graph']
    >['persistedQueryList']
  >;
  onPublishClick: () => void;
}) => {
  const shouldShowNewUI = useLDFlag('gov-pq-ux-sort-filter-delete');

  return (
    <>
      {shouldShowNewUI ? (
        <PageTitle title={persistedQueryList.name} />
      ) : (
        <>
          <PageTitle title="Persisted Query List Details" />
          <section className="mx-8 mt-8 flex items-center">
            <h2 className="flex-1">{persistedQueryList.name ?? '--'}</h2>
          </section>
        </>
      )}
      <Card className="m-8 flex h-full">
        <CardBody className="items-center justify-center">
          <div className="my-20 text-center">
            <Moon />
            <Heading as="h1" size="xl" className="mt-8">
              Add operations to your persisted queries list
            </Heading>
            <div className="mt-2 max-w-120 text-secondary">
              Use persisted queries to enforce a safelist on your variants or to
              manage a list of short query IDs that can be used in place of full
              freeform GraphQL in requests. Learn more about what you can do in
              the{' '}
              <Link isExternal to={DocsRouter.path('PersistedQueries')}>
                docs
              </Link>
              .
            </div>
            <Button className="mt-8" onClick={onPublishClick}>
              Publish operations
            </Button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
